import axios from 'axios'
import { storageKeys } from '@config'

// Client pour les routes publiques (/mobile/*)
// Pas de redirection vers /login sur 401
const publicApiClient = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_API_BASE_URL,
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 120000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})

// Injecte le token s'il existe (utile quand l'utilisateur est connecté)
publicApiClient.interceptors.request.use(config => {
  const token = localStorage.getItem(storageKeys.authToken)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Renvoie directement response.data
publicApiClient.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

export default publicApiClient
